var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadButton = function SvgDownloadButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#downloadButton_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "#4F52C3",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.985 12.7c.397.21.547.703.337 1.1-.823 1.548-1.109 3.96-1.139 4.991a.812.812 0 1 1-1.624-.047c.032-1.105.326-3.823 1.328-5.707a.812.812 0 0 1 1.098-.337Z",
    fill: "#9D9FFC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.09,
    cy: 10.785,
    r: 0.901,
    transform: "rotate(2.97 8.09 10.785)",
    fill: "#9D9FFC",
    stroke: "#9D9FFC",
    strokeWidth: 0.203
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.104 15.414h1.644c.92 0 1.375 1.116.723 1.768l-4.744 4.744a1.03 1.03 0 0 1-1.458 0l-4.744-4.744c-.652-.652-.187-1.768.733-1.768h1.644v-5.169c0-.568.465-1.033 1.034-1.033h4.135c.568 0 1.033.465 1.033 1.033v5.169Zm-9.303 11.37a1.037 1.037 0 0 1-1.034-1.033c0-.569.465-1.034 1.034-1.034h12.405c.568 0 1.033.466 1.033 1.034 0 .569-.465 1.034-1.034 1.034H11.802Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "downloadButton_svg__a",
    x: 0,
    y: 0,
    width: 36,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_345550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_301_345550",
    result: "shape"
  })))));
};
export default SvgDownloadButton;